import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import axios from 'axios';
import RouteLoadingScreen from './RouteLoadingScreen';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const CompletionGuard = ({
  shouldCheck,
  endpoint,
  redirectTo,
  backgroundClass = 'bg-[#F8F9FC]',
  children,
}) => {
  const [status, setStatus] = useState(shouldCheck ? 'checking' : 'ready');
  const navigate = useNavigate();

  useEffect(() => {
    let active = true;

    if (!shouldCheck) {
      setStatus('ready');
      return () => {
        active = false;
      };
    }

    setStatus('checking');

    axios
      .get(`${API_URL}${endpoint}`)
      .then((res) => {
        if (!active) {
          return;
        }

        if (!res.data.completed) {
          navigate(redirectTo, { replace: true });
          return;
        }

        setStatus('ready');
      })
      .catch(() => {
        if (active) {
          // Fail open so a transient API issue never locks a user out.
          setStatus('ready');
        }
      });

    return () => {
      active = false;
    };
  }, [endpoint, navigate, redirectTo, shouldCheck]);

  if (status === 'checking') {
    return <RouteLoadingScreen backgroundClass={backgroundClass} message={null} />;
  }

  return children || <Outlet />;
};

export default CompletionGuard;
